function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "D78CBA26-0A60-4B8A-83E9-70F478CF2C8A");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Daily-Calendar-and-Booking-Form",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "LAP-UI-Elements---Left-Panel",
  transform: "translate(-76.000000, -836.000000)",
  fill: "#14006B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "search-results",
  transform: "translate(76.000000, 800.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Customer/Gray",
  transform: "translate(0.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.88134766,10.3046875 C11.7573242,10.3046875 13.284668,8.63623047 13.284668,6.60253906 C13.284668,4.58544922 11.765625,3 9.88134766,3 C8.00537109,3 6.46972656,4.61035156 6.46972656,6.61914062 C6.47802734,8.64453125 8.00537109,10.3046875 9.88134766,10.3046875 Z M9.88134766,9.05957031 C8.75244141,9.05957031 7.79785156,7.98046875 7.79785156,6.61914062 C7.78955078,5.27441406 8.73583984,4.24511719 9.88134766,4.24511719 C11.0268555,4.24511719 11.9648438,5.2578125 11.9648438,6.60253906 C11.9648438,7.96386719 11.0185547,9.05957031 9.88134766,9.05957031 Z M14.7954102,17.5844727 C16.1235352,17.5844727 16.7543945,17.1777344 16.7543945,16.2978516 C16.7543945,14.2060547 14.1230469,11.2592773 9.87304688,11.2592773 C5.63134766,11.2592773 3,14.2060547 3,16.2978516 C3,17.1777344 3.63085938,17.5844727 4.95898438,17.5844727 L14.7954102,17.5844727 Z M15.1274414,16.3393555 L4.62695312,16.3393555 C4.42773438,16.3393555 4.34472656,16.28125 4.34472656,16.1235352 C4.34472656,14.8618164 6.3203125,12.5043945 9.87304688,12.5043945 C13.4257812,12.5043945 15.409668,14.8618164 15.409668,16.1235352 C15.409668,16.28125 15.3266602,16.3393555 15.1274414,16.3393555 Z",
  id: "customer-blue"
})))));

var SvgCustomer = function SvgCustomer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customer.6edb0a06.svg";
export { ForwardRef as ReactComponent };